import React, { FC, InputHTMLAttributes, forwardRef } from 'react';
import styles from './index.style.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type: string;
  isDisabled?: boolean;
  className?: string;
  value?: string;
}

const Input: FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
  (
    { type = 'text', isDisabled = false, className = '', value = '', ...rest },
    ref
  ) => {
    return (
      <input
        type={type}
        disabled={isDisabled}
        className={`${className} ${styles.input}`}
        ref={ref}
        value={value}
        {...rest}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
